import React, {Component} from 'react'
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'
import '../../styles/HomePageStyles/homepage.css'
import '../../styles/HomePageStyles/PlatformStyles/platformgeneric.css'


import TokenCountdown from './TokenCountdown.js'

import KronnBot from './../../resources/HomePageResources/kronn-bot.svg'
import KronnCoin from './../../resources/HomePageResources/kronn-coin.svg'
import Wallet from './../../resources/HomePageResources/wallet.svg'

import NewYorkPlatform from './Platforms/NewYorkPlatform.js'
import TokyoPlatform from './Platforms/TokyoPlatform.js'
import LondonPlatform from './Platforms/LondonPlatform.js'

import IndependentPlatform from './Platforms/IndependentPlatform.js'


class HomePage extends Component{
    render(){
        return(
            <section className="hp__container" id='home-page-anchor'>
                {/* <img src={WhiteBackground} /> */}

                <h1 className="hp__title-container" style={{
                    right: (this.props.windowDimensions.windowWidth > 1080) ? this.props.windowDimensions.windowWidth*0.1+375 : this.props.windowDimensions.windowWidth*0.05,
                    left: (this.props.windowDimensions.windowWidth > 820) ? '' :'10vw'
                }}>
                    Explore the network

                </h1>

                <div className="hp__token-countdown">
                    <TokenCountdown/>
                </div>


                <div className="hp__platform-animation-container">
                    <div className="hp__tokyo">
                        <TokyoPlatform/>
                    </div>

                    <div className="hp__new-york">
                        <NewYorkPlatform/>
                    </div>

                    <div className="hp__london">
                        <LondonPlatform/>
                    </div>

                    <div className="hp__kronn-hq">
                        <img className="hp__kronn-hq" src={require('../../resources/HomePageResources/kronn-main.svg')}/>
                    </div>

                    <div className="hp__robot-wallet__container">
                        <div className="hp__robot-coin__container">
                            <img src={KronnBot} className="hp__robot-img" />
                            <img src={KronnCoin} className="hp__coin-img" />
                        </div>
                        <img src={Wallet} className="hp__wallet-img" />
                    </div>
                </div>

                <div className="hp__self-sus-platform">
                    <IndependentPlatform/>
                </div>

            </section>
        )
    }
}

const mapStatesToProps = (state) =>{
    return{
        windowDimensions: state.windowDimensions,
    }
}

export default connect(mapStatesToProps)(HomePage)



// WEBPACK FOOTER //
// ./src/components/HomePage/HomePage.js